import React from 'react';
import InsyncModelWidgetBuilder from './InsyncModelWidgetBuilder';
import InsyncModelWidgetRenderer from './InsyncModelWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { InsyncModelWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableList } from '@fortawesome/free-solid-svg-icons';

export { default as InsyncModelWidgetBuilder } from './InsyncModelWidgetBuilder';
export { default as InsyncModelWidgetRenderer } from './InsyncModelWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'insync_model',
  meta: {
    label: 'InSync Model',
    icon: React.createElement(FontAwesomeIcon, { icon: faTableList }),
    description: 'The live InSync model (LineItem x fiscal year) for the assigned asset',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'INSYNC_MODEL',
    params: [],
  },
  defaultSize: { w: 24, h: 10, minW: 6, minH: 5 },
  defaultConfig: () => ({} as InsyncModelWidgetConfig),
  Builder: InsyncModelWidgetBuilder,
  Renderer: InsyncModelWidgetRenderer,
  Preview,
};
